import InputTextComponent from './InputTextComponent';
export default InputTextComponent;
